<template>
  <div @click="visible = true">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-pcb-converter-modal"
    >
      <div class="c-pcb-converter">
        <img ref="cropper" :src="image" class="cropper" />
        <label v-if="!image" class="cropper-upload" for="upload">
          <div class="upload-box">
            <i class="iconfont iconupload-folder" />
          </div>
          <span v-html="$t('light.supportFormat', ['150*60'])"></span>
          <input
            id="upload"
            type="file"
            @change="onUpload"
            :value="image"
            accept="image/gif, image/png, image/jpeg"
          />
        </label>
        <div class="buttons" v-if="image">
          <md-button class="button" @click="image = null">
            {{ $t("back") }}
          </md-button>
          <md-button class="button" v-if="image" @click="onConversion">
            {{ $t("conversion") }}
          </md-button>
        </div>
        <i class="close iconfont iconclose-o" @click="visible = false" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import Cropper from "cropperjs";
import GifFrames from "gif-frames";
import "cropperjs/dist/cropper.css";

export default {
  name: "CPcbConverterNew",
  data() {
    return {
      visible: false,
      image: null,
      cropper: null,
      coords: [
        // 0
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,

        // 1
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,

        // 2
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,

        // 3
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        -1,
        58,
        59,

        // 4
        60,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        -1,
        72,
        73,
        -1,

        // 5
        75,
        76,
        77,
        79,
        -1,
        80,
        -1,
        -1,
        81,
        85,
        86,
        -1,
        87,
        88,
        89,
      ],
    };
  },
  methods: {
    onUpload(e) {
      const file = e.target.files[0];
      if (file && file.type.includes("image/")) {
        if (file.type === "image/gif") {
          this.buildFrames(file);
        } else {
          const image = new Image();
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.image = URL.createObjectURL(file);
          };
        }
      } else {
        e.target.value = null;
        this.$message.info(this.$t("light.fileErrorInfo"));
      }
    },
    onConversion() {
      const canvas = this.cropper.getCroppedCanvas({
        width: 15,
        height: 6,
      });
      this.$emit("change", { RGB: this.getRGB(canvas) });
      this.$message.destroy();
      this.visible = false;
    },
    getRGB(canvas) {
      const { width, height } = canvas;
      const context = canvas.getContext("2d");
      const imageData = context.getImageData(0, 0, width, height);
      let RGB = [];

      for (let index = 0; index < 90; index++) {
        RGB.push("#000000");
      }
      this.coords.map((RGBIndex, i) => {
        let index = i * 4;
        index = index - (index % 4);
        index =
          index >= imageData.data.length ? imageData.data.length - 4 : index;
        let r = imageData.data[index].toString(16);
        let g = imageData.data[index + 1].toString(16);
        let b = imageData.data[index + 2].toString(16);
        r = (r.length === 1 ? "0" : "") + r;
        g = (g.length === 1 ? "0" : "") + g;
        b = (b.length === 1 ? "0" : "") + b;
        if (RGBIndex > -1) {
          RGB[RGBIndex] = "#" + r + g + b;
        }
      });
      return RGB;
    },
    buildFrames(file) {
      this.$message.info(this.$t("light.build"), 60000);
      GifFrames({
        url: URL.createObjectURL(file),
        frames: "all",
        outputType: "canvas",
      })
        .then((frameData) => {
          let frames = [];
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = 15;
          canvas.height = 6;

          const width = frameData[0].getImage().width;
          const height = (width * canvas.height) / canvas.width;
          const sy = (frameData[0].getImage().height - height) / 2;

          frameData.map((item) => {
            context.drawImage(
              item.getImage(),
              0,
              sy,
              width,
              height,
              0,
              0,
              canvas.width,
              canvas.height
            );
            frames.push({
              frame_index: frames.length + 1,
              frame_RGB: this.getRGB(canvas),
            });
          });
          this.$emit("change", { frames });
          this.$message.destroy();
          this.visible = false;
        })
        .catch(() => {
          this.$message.destroy();
        });
    },
  },
  watch: {
    image(image) {
      if (image) {
        setTimeout(() => {
          this.cropper = new Cropper(this.$refs.cropper, {
            viewMode: 1,
            dragMode: "move",
            aspectRatio: 15 / 6,
            minCropBoxWidth: 15,
            background: false,
            toggleDragModeOnDblclick: false,
          });
        }, 500);
      } else {
        this.cropper && this.cropper.destroy();
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.cropper && this.cropper.destroy();
      this.image = null;
    });
  },
};
</script>
<style lang="scss" scoped>
.c-pcb-converter {
  @include flex-center;
  width: 1250px;
  height: 800px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .cropper {
    width: 100%;
    height: 100%;
    visibility: hidden;
  }

  .cropper-container {
    .cropper-view-box {
      outline: 2px solid $primary-color;
    }
    .cropper-modal {
      opacity: 0.25;
    }
    .cropper-point,
    .cropper-line {
      background-color: $primary-color;
    }
  }

  .cropper-upload {
    @include flex-center;
    width: 100%;
    flex-direction: column;
    position: absolute;
    top: 200px;
    left: 0;
    cursor: pointer;

    .upload-box {
      @include flex-center;
      width: 800px;
      height: 304px;
      border: 2px solid $primary-color;
      color: $primary-color;
      margin-bottom: 20px;

      i {
        font-size: 60px;
      }
    }

    input {
      display: none;
    }

    span {
      color: #ffffff;
      font-size: 20px;
    }
  }

  .buttons {
    @include flex-center;
    width: 100%;
    position: absolute;
    bottom: 100px;
    left: 0;

    .button {
      width: 450px;
      height: 53px;
      background-color: $primary-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }

  .close {
    @include icon-hover;
    font-size: 40px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
